(() => {
  const init = () => {
    document.querySelectorAll('[data-polaris-hero]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const slides = [...root.querySelectorAll('[data-polaris-slide]')];
      const selectors = [...root.querySelectorAll('[data-polaris-index]')];
      let current = 0;
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        selectors.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
      };
      selectors.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.polarisIndex))));
      root.querySelector('[data-polaris-prev]').addEventListener('click', () => show(current - 1));
      root.querySelector('[data-polaris-next]').addEventListener('click', () => show(current + 1));
      root.addEventListener('keydown', event => { if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1)); } });
      let touchStart;
      root.addEventListener('touchstart', event => { touchStart = { x:event.changedTouches[0].clientX, y:event.changedTouches[0].clientY }; }, {passive:true});
      root.addEventListener('touchend', event => { if(!touchStart) return; const dx=event.changedTouches[0].clientX-touchStart.x,dy=event.changedTouches[0].clientY-touchStart.y; if(Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5) show(current+(dx<0?1:-1)); touchStart=null; }, {passive:true});
    });
    document.querySelectorAll('[data-polaris-story]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready='true';
      root.querySelectorAll('[data-polaris-meaning]').forEach(button => button.addEventListener('click', () => {
        root.querySelectorAll('[data-polaris-meaning]').forEach(other => other.setAttribute('aria-expanded',String(other===button)));
        root.querySelectorAll('[data-polaris-insight]').forEach(panel => { panel.hidden = panel.dataset.polarisInsight !== button.dataset.polarisMeaning; });
      }));
    });
  };
  init();
  document.addEventListener('shopify:section:load',init);
})();